__turbopack_context__.v({
  "accordion": "xI6fZG_accordion",
  "body": "xI6fZG_body",
  "button": "xI6fZG_button",
  "details": "xI6fZG_details",
  "heading": "xI6fZG_heading",
  "summary": "xI6fZG_summary",
});
